import React from 'react'
import { Link } from 'react-router-dom'
import flood from "../assets/flood-map.jpg"
import epidemics from "../assets/epidemics-map.jpg"
import drought from "../assets/drought-map.jpg"
import cyclone from "../assets/cyclone-map.jpg"
import lighting from "../assets/lighting-map.jpg"
import earthquake from "../assets/earthquake-map.jpg"
const Home = () => {
  return (
    <div>
      <header id="head">
        <div className="banner-content">
          <h1>Geospatial Smart<br /> Thinkers</h1>
          <p>Navigate Nature's Challenges: Your Guide to India's Natural Hazards Geoportal. </p>
          {/* <Link to="/" onClick={() => window.scrollTo(0, 0)}> <button className='home_page_btn'>
            Create a Choropleth Map</button></Link> */}
        </div>
      </header>
      
      <div className="cards_container">
        <h2>India's Natural Hazards Geoportal</h2>
        <div className="row">
          <div className="col-md-4">
            <div className="card_item">
            <Link to="/drought" > <img src={drought} alt='map' />
              <h4>Drought Map</h4></Link>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card_item">
            <Link to="/earthquake"> <img src={earthquake} alt='map' />
              <h4>Earthquake Map</h4></Link>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card_item">
            <Link to="/cyclone">  <img src={cyclone} alt='map' />
              <h4>Cyclone Map</h4></Link>
            </div>
          </div>


          <div className="col-md-4">
            <div className="card_item">
            <Link to="/flood"><img src={flood} alt='map' />
              <h4>Flood Map</h4></Link>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card_item">
            <Link to="/lighting"> <img src={lighting} alt='map' />
              <h4>Lighting Map</h4></Link>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card_item">
            <Link to="/epidemics"> <img src={epidemics} alt='map' />
              <h4>Epidemics Map</h4></Link>
            </div>
          </div>

        </div>
        



      </div>
    </div>
  )
}

export default Home